/**
 * This is the main module of the application and defines the global dependencies,
 * sets up application-wide client-side features and functionality (such as the PJAX
 * implementation, the spinner.etc.) and also setups the required routing.
 */

// following line has to be THE FIRST LINE EXECUTED
import '@/bootstrap';

import $ from 'jquery';

import 'bootstrap/js/transition.js';
import 'bootstrap/js/collapse.js';
import 'bootstrap/js/dropdown.js';
import 'bootstrap/js/modal.js';
import 'bootstrap/js/tooltip.js';
import 'bootstrap/js/popover.js';

import '@/lib/jquery/security.js';

import Vue from 'vue';

import { Composer } from '@/domain/services/Composer';
import { GlobalComponentsResolver } from '@/legacy/GlobalComponentsResolver';

import initAlertValidation from '@/common/alert-validation.js';
import initBoxer from '@/lib/boxer';
import initCookieNotice from '@/common/cookie-notice';
import { init as initDarkmode } from '@/common/darkmode.js';
import initFiltertron from './lib/filtertron/filtertron.js';
import initFiltertronTray from './lib/filtertron/filtertron-tray.js';
import initGlobalListeners from '@/common/global';
import initInterfaceTextPopover from '@/modules/interface-text/interface-text-popovers';
import initLinkPoster from '@/common/link-poster';
import initMainMenu from '@/lib/main-menu.js';
import initMultiselect from '@/common/multiselect';
import initPaginationSelector from '@/common/pagination-selector';
import { initPing } from '@/common/ping';
import initPusher from '@/common/pusher';
import initRedirector from '@/lib/redirector';
import initSimpleModal from '@/common/simple-modal';
import initSixDigitCode from '@/common/six-digit-code.js';
import initSkipToContent from '@/common/accessibility';
import initTabular from '@/lib/tabular/tabs.js';
import initTooltips from '@/lib/tooltip';

import pjax from '@/vendor/pjax/pjax';

// eslint-disable-next-line no-undef, camelcase
__webpack_public_path__ = window.__webpack_public_path__ || '/';

require('./lib/select2.js');
require('./lib/moment.js');

Vue.config.ignoredElements = ['zapier-app-directory'];
Vue.config.productionTip = false;

$(document).on('pjax:complete', () => {
	Composer.loadModule();
	GlobalComponentsResolver.loadGlobalComponentsModules();
});

$(document).on('ready', async () => {
	initPusher();

	await Composer.loadModule();
	await GlobalComponentsResolver.loadGlobalComponentsModules();

	initDarkmode();
	initMainMenu();
	initRedirector();
	initMultiselect();
	initLinkPoster();
	initSimpleModal();
	initSkipToContent();
	initCookieNotice();
	initTooltips();

	require('./common/strip.js').init();
	require('./modules/modules.js');

	pjax.init();

	initGlobalListeners();
	initPing();
	initBoxer();
	initFiltertron();
	initFiltertronTray();
	initTabular();
	initAlertValidation();
	initInterfaceTextPopover();
	initSixDigitCode();
	initPaginationSelector();
});
